// extracted by mini-css-extract-plugin
export var addViewLink = "_m-1";
export var availabilityIcon = "_m-16";
export var availabilitySelectionIcon = "_m-15";
export var backButton = "_m-2";
export var backIcon = "_m-z";
export var conversationCount = "_m-3";
export var dragHandle = "_m-5";
export var dropdown = "_m-e";
export var dropdownIcon = "_m-7";
export var dropdownOption = "_m-6";
export var dropdownTriangle = "_m-d";
export var expand = "_m-f";
export var folder = "_m-i";
export var folderItem = "_m-c";
export var icon = "_m-8";
export var iconRow = "_m-9";
export var image = "_m-a";
export var logo = "_m-b";
export var navContainer = "_m-h";
export var navigationFooter = "_m-g";
export var pageShell = "_m-0";
export var placeholderAvailable = "_m-11";
export var placeholderBox = "_m-14";
export var placeholderBusy = "_m-13";
export var placeholderUnavailable = "_m-12";
export var profile = "_m-k";
export var profileContainer = "_m-m";
export var profileDropdown = "_m-n";
export var profileImage = "_m-l";
export var profileMain = "_m-o";
export var profileSubtitle = "_m-q";
export var profileTitle = "_m-p";
export var reorderIcon = "_m-r";
export var sentLine = "_m-u";
export var settingsHeader = "_m-s";
export var sidenavTextColor = "_m-y";
export var spamLine = "_m-t";
export var subitemWithTag = "_m-4";
export var supportItems = "_m-j";
export var teamText = "_m-10";
export var viewLine = "_m-x";
export var viewLineButton = "_m-w";
export var viewLineButtons = "_m-v";